function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.808,
    height: 41.808,
    viewBox: "0 0 41.808 41.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29",
    d: "M33.156 40.808H7.651A7.651 7.651 0 0 1 0 33.156V7.651A7.651 7.651 0 0 1 7.651 0h25.5a7.651 7.651 0 0 1 7.651 7.651v25.5a7.651 7.651 0 0 1-7.646 7.657zm0 0",
    transform: "translate(.5 .5)",
    style: {
      fill: "#f9f9f9",
      stroke: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4207",
    d: "M169.671 145.752a7.033 7.033 0 0 1-2.5-5.38v-2.925a7.353 7.353 0 0 0-6.3-7.263v-1.134a1.05 1.05 0 0 0-2.1 0v1.134a7.352 7.352 0 0 0-6.3 7.263v2.927a7.042 7.042 0 0 1-2.507 5.388 1.837 1.837 0 0 0 1.2 3.232h17.32a1.838 1.838 0 0 0 1.186-3.242zm0 0",
    transform: "translate(-138.921 -119.692)",
    style: {
      fill: "#faa100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4208",
    d: "M220.658 355.149a3.941 3.941 0 0 0 3.856-3.149H216.8a3.944 3.944 0 0 0 3.858 3.149zm0 0",
    transform: "translate(-199.754 -321.649)",
    style: {
      fill: "#faa100"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.00ebeeb80c1458c51e382741adfeb64e.svg";
export { ForwardRef as ReactComponent };